import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

export const GenerationContext = createContext();

export function GenerationProvider({ children }) {
  const [selectedGeneration, setSelectedGeneration] = useState('allgen');

  return (
    <GenerationContext.Provider value={{ selectedGeneration, setSelectedGeneration }}>
      {children}
    </GenerationContext.Provider>
  );
}

GenerationProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
